import React from 'react';
import { style } from 'typestyle';
import { colorWhite, rebrand } from '../../../../theme/color';
import SearchSuggestionItem, { SearchSuggestionType } from '../../atoms/SearchSuggestionItem';
import { constantHeaderWithSearchHeight } from '../../config';
import { constantPlayerHeight } from '../../../../theme/constant';
import { SearchSuggestionSkeleton } from '../skeletons/SearchSuggestionSkeleton';
const styles = {
  wrapper: style({
    backgroundColor: colorWhite.toHexString(),
    border: `solid 1px ${rebrand.neutralOnDark[20]}`,
    borderTop: 0,
    maxHeight: `calc(100dvh - ${constantHeaderWithSearchHeight}px - ${constantPlayerHeight})`,
    overflowY: 'auto',
  }),
};

type Props = {
  entities: SearchSuggestionType[];
  loading: boolean;
};

const SearchSuggestion: React.FC<Props> = ({ entities, loading }) => {
  return (
    <div className={styles.wrapper} data-test-view-search-suggestion>
      {loading ? (
        <>
          <SearchSuggestionSkeleton />
          <SearchSuggestionSkeleton />
          <SearchSuggestionSkeleton />
        </>
      ) : (
        entities.map((entity, i) => <SearchSuggestionItem key={i + entity.type} entity={entity} index={i} />)
      )}
    </div>
  );
};

export default SearchSuggestion;
